// @flow
import * as React from 'react';

type Props = {
}

const WEB_NOTIFICATIONS_PERMISSION_GRANTED = 'granted';

const WebNotificationsPermissionRequest = () => {
    const requestPermission = React.useCallback(async () => {
        if (window.Notification && window.Notification?.permission !== WEB_NOTIFICATIONS_PERMISSION_GRANTED) {
            await window.Notification.requestPermission();
        }
    }, []);

    React.useEffect(() => {
        requestPermission();
    }, [requestPermission]);

    return null;
};

export default WebNotificationsPermissionRequest;
